var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-overlay", { attrs: { show: _vm.searchingConfig } }, [
    _c("form", { attrs: { "data-vv-scope": "flow-part-1" } }, [
      _c("div", { staticClass: "row mb-3" }, [
        _c("div", { staticClass: "col-12" }, [
          _c("h4", [_vm._v("Datos para el flujo")]),
          !_vm.isGore &&
          (_vm.wizardData.fileCategory === "numInt" ||
            _vm.wizardData.fileCategory === "numOf")
            ? _c("span", [
                _vm._v(" Este expediente "),
                _vm.wizardData.fileCategory === "numInt"
                  ? _c("span", [_vm._v(" podrá tener numeración interna ")])
                  : _vm._e(),
                _vm.wizardData.fileCategory === "numOf"
                  ? _c("span", [
                      _vm._v(" podrá ser tramitado por Oficina de Partes ")
                    ])
                  : _vm._e()
              ])
            : _vm._e()
        ])
      ]),
      _c("div", { staticClass: "row mb-3" }, [
        _c(
          "div",
          { staticClass: "col-md-6" },
          [
            _c("vs-input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'"
                }
              ],
              staticClass: "w-100",
              attrs: {
                label: "Nombre para el flujo (*)",
                maxlength: "120",
                name: "name",
                danger: _vm.errors.has("flow-part-1.name"),
                "danger-text": _vm.errors.first("flow-part-1.name")
              },
              model: {
                value: _vm.step.name,
                callback: function($$v) {
                  _vm.$set(_vm.step, "name", $$v)
                },
                expression: "step.name"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-md-6" },
          [
            _c("vs-input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'"
                }
              ],
              staticClass: "w-100",
              attrs: {
                label: "Resumen (*)",
                name: "description",
                danger: _vm.errors.has("flow-part-1.description"),
                "danger-text": _vm.errors.first("flow-part-1.description"),
                maxlength: "550"
              },
              model: {
                value: _vm.step.description,
                callback: function($$v) {
                  _vm.$set(_vm.step, "description", $$v)
                },
                expression: "step.description"
              }
            })
          ],
          1
        )
      ]),
      !_vm.step.oldFlow
        ? _c("div", { staticClass: "row mb-3" }, [
            _c(
              "div",
              { staticClass: "col-md-6 mt-3" },
              [
                _c("BooleanParameter", {
                  attrs: {
                    "is-approval-sign": true,
                    "param-id": "aprobaciones.firmas.ubicacion",
                    "data-cy": "set-signature-position"
                  },
                  on: { input: _vm.onSetSignaturePositionChange },
                  model: {
                    value: _vm.step.setSignaturePosition,
                    callback: function($$v) {
                      _vm.$set(_vm.step, "setSignaturePosition", $$v)
                    },
                    expression: "step.setSignaturePosition"
                  }
                })
              ],
              1
            ),
            _c("div", { staticClass: "col-md-6 mt-3" }, [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-md-8 d-flex align-items-end" },
                  [
                    _c("label", [_vm._v("Flujo privado")]),
                    _c("InfoPrivateFlow")
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-md-2" },
                  [
                    _c(
                      "vs-radio",
                      {
                        attrs: {
                          "vs-name": "private",
                          "vs-value": true,
                          "data-cy": "privateYes"
                        },
                        model: {
                          value: _vm.step.private,
                          callback: function($$v) {
                            _vm.$set(_vm.step, "private", $$v)
                          },
                          expression: "step.private"
                        }
                      },
                      [_vm._v(" Si ")]
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-md-2" },
                  [
                    _c(
                      "vs-radio",
                      {
                        attrs: {
                          "vs-name": "private",
                          "vs-value": false,
                          "data-cy": "privateNo"
                        },
                        model: {
                          value: _vm.step.private,
                          callback: function($$v) {
                            _vm.$set(_vm.step, "private", $$v)
                          },
                          expression: "step.private"
                        }
                      },
                      [_vm._v(" No ")]
                    )
                  ],
                  1
                )
              ])
            ])
          ])
        : _vm._e(),
      _c("div", { staticClass: "row mb-3" }, [
        _c("div", { staticClass: "col-md-6" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-md-8 d-flex align-items-end" },
              [
                _c("label", [_vm._v("Estampar aprobaciones")]),
                _c("InfoApprovalStamp")
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-md-2" },
              [
                _c(
                  "vs-radio",
                  {
                    attrs: {
                      "vs-name": "pdfStamp",
                      "vs-value": true,
                      "data-cy": "pdfStampYes"
                    },
                    model: {
                      value: _vm.step.pdfStamp,
                      callback: function($$v) {
                        _vm.$set(_vm.step, "pdfStamp", $$v)
                      },
                      expression: "step.pdfStamp"
                    }
                  },
                  [_vm._v(" Si ")]
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-md-2" },
              [
                _c(
                  "vs-radio",
                  {
                    attrs: {
                      "vs-name": "pdfStamp",
                      "vs-value": false,
                      "data-cy": "pdfStampNo"
                    },
                    model: {
                      value: _vm.step.pdfStamp,
                      callback: function($$v) {
                        _vm.$set(_vm.step, "pdfStamp", $$v)
                      },
                      expression: "step.pdfStamp"
                    }
                  },
                  [_vm._v(" No ")]
                )
              ],
              1
            )
          ])
        ]),
        _c("div", { staticClass: "col-md-6" })
      ])
    ]),
    _c("form", { attrs: { "data-vv-scope": "flow-part-2" } }, [
      _c("div", { staticClass: "row mb-3" }, [
        _c("div", { staticClass: "col-12" }, [
          _c("h4", [_vm._v("Detalle del flujo")])
        ])
      ]),
      _c("div", { staticClass: "row mb-5" }, [
        _c(
          "div",
          { staticClass: "col-3" },
          [
            _c(
              "vs-select",
              {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                staticClass: "w-100",
                attrs: {
                  autocomplete: "",
                  label: "Tipo de paso (*)",
                  name: "stepType",
                  danger: _vm.errors.has("flow-part-2.stepType"),
                  "danger-text": _vm.errors.first("flow-part-2.stepType")
                },
                on: { change: _vm.searchOffice },
                model: {
                  value: _vm.stepType,
                  callback: function($$v) {
                    _vm.stepType = $$v
                  },
                  expression: "stepType"
                }
              },
              [
                _c("vs-select-item", {
                  attrs: { value: _vm.stepTypes.USER, text: "Usuario" }
                }),
                _vm.wizardData.fileCategory !== "int"
                  ? _c("vs-select-item", {
                      attrs: { value: _vm.stepTypes.OFFICE, text: "Oficina" }
                    })
                  : _vm._e()
              ],
              1
            )
          ],
          1
        ),
        _vm.stepType === this.stepTypes.OFFICE
          ? _c(
              "div",
              { staticClass: "col-6" },
              [
                _c("list-offices", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: {
                        required: _vm.stepType === this.stepTypes.OFFICE
                      },
                      expression:
                        "{ required: stepType === this.stepTypes.OFFICE }"
                    }
                  ],
                  ref: "groupStep",
                  staticClass: "w-100 mb-1",
                  attrs: {
                    autocomplete: "",
                    label: "Oficina del responsable (*)",
                    name: "groupStep",
                    "data-vv-as": "oficina",
                    typeList: _vm.stepType,
                    "validate-lider": "",
                    withFilters: "",
                    officeType: _vm.wizardData.fileCategory,
                    filterMyOffices: _vm.filterUserOffices,
                    danger: _vm.errors.has("flow-part-2.groupStep"),
                    "danger-text": _vm.errors.first("flow-part-2.groupStep")
                  },
                  model: {
                    value: _vm.groupStep,
                    callback: function($$v) {
                      _vm.groupStep = $$v
                    },
                    expression: "groupStep"
                  }
                }),
                _c("small", { staticClass: "text-danger" }, [
                  _vm._v(
                    " Si le falta una oficina, favor notificar al equipo de Soporte para que verifiquen que esté correctamente configurada "
                  )
                ])
              ],
              1
            )
          : _vm._e(),
        _vm.stepType === _vm.stepTypes.USER
          ? _c(
              "div",
              { staticClass: "col-6" },
              [
                _c("list-user", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: { required: _vm.stepType === _vm.stepTypes.USER },
                      expression: "{ required: stepType === stepTypes.USER }"
                    }
                  ],
                  ref: "userStep",
                  staticClass: "w-100",
                  attrs: {
                    autocomplete: "",
                    label: "Usuario (*)",
                    name: "userStep",
                    withFilters: "",
                    danger: _vm.errors.has("flow-part-2.userStep"),
                    "danger-text": _vm.errors.first("flow-part-2.userStep")
                  },
                  model: {
                    value: _vm.userStep,
                    callback: function($$v) {
                      _vm.userStep = $$v
                    },
                    expression: "userStep"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.stepType !== _vm.stepTypes.OFFICE
          ? _c(
              "div",
              { staticClass: "col-3" },
              [
                _c(
                  "b-form-group",
                  { attrs: { label: "Tipo de rol (*)" } },
                  [
                    _c("v-select", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      class: { danger: _vm.errors.has("flow-part-2.rolType") },
                      attrs: {
                        id: "rolType",
                        label: "label",
                        options: _vm.rolTypesOption,
                        reduce: function(rol) {
                          return rol.id
                        },
                        name: "rolType"
                      },
                      model: {
                        value: _vm.rolType,
                        callback: function($$v) {
                          _vm.rolType = $$v
                        },
                        expression: "rolType"
                      }
                    }),
                    _c("InfoRolType"),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.errors.has("flow-part-2.rolType"),
                            expression: "errors.has('flow-part-2.rolType')"
                          }
                        ],
                        staticClass:
                          "danger span-text-validation-danger v-enter-to"
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.errors.first("flow-part-2.rolType")) +
                            " "
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _vm.stepType === _vm.stepTypes.OFFICE
          ? _c(
              "div",
              { staticClass: "col-3" },
              [
                _c(
                  "b-form-group",
                  { attrs: { label: "Tipo de rol (*)" } },
                  [
                    _c("v-select", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      class: { danger: _vm.errors.has("flow-part-2.rolType") },
                      attrs: {
                        label: "label",
                        options: _vm.rolTypesOfficeOption,
                        reduce: function(rol) {
                          return rol.id
                        },
                        name: "rolType"
                      },
                      model: {
                        value: _vm.rolType,
                        callback: function($$v) {
                          _vm.rolType = $$v
                        },
                        expression: "rolType"
                      }
                    }),
                    _c(
                      "div",
                      { staticClass: "text-right" },
                      [
                        _vm._v(" info "),
                        _c(
                          "b-button",
                          {
                            staticClass: "btn-icon rounded-circle mt-1",
                            attrs: {
                              size: "sm",
                              id: "popover-button-default",
                              variant: "flat-primary"
                            }
                          },
                          [_c("feather-icon", { attrs: { icon: "InfoIcon" } })],
                          1
                        ),
                        _c(
                          "b-popover",
                          {
                            attrs: {
                              target: "popover-button-default",
                              triggers: "focus",
                              placement: "top"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "title",
                                  fn: function() {
                                    return [
                                      _c("span", [_vm._v("Tipos de roles!")])
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              false,
                              2187985360
                            )
                          },
                          [
                            _c("span", [
                              _c("b", [_vm._v("+ Numerar/tramitar:")]),
                              _vm._v(
                                " Permite firmar documentos, esto cuenta como la aprobación, se coloca un estampado de numeración o trámite. "
                              )
                            ])
                          ]
                        )
                      ],
                      1
                    ),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.errors.has("flow-part-2.rolType"),
                            expression: "errors.has('flow-part-2.rolType')"
                          }
                        ],
                        staticClass:
                          "danger span-text-validation-danger v-enter-to"
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.errors.first("flow-part-2.rolType")) +
                            " "
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e()
      ]),
      _c("div", { staticClass: "row mb-3" }, [
        _c(
          "div",
          { staticClass: "col-12 d-flex align-items-end justify-content-end" },
          [
            _c(
              "vs-button",
              {
                attrs: {
                  color: "primary",
                  icon: "add",
                  disabled: _vm.blockButton,
                  "data-cy": "add-step"
                },
                on: {
                  click: function($event) {
                    return _vm.addStep()
                  }
                }
              },
              [_vm._v(" Agregar Paso ")]
            )
          ],
          1
        )
      ]),
      _vm.step.steps.length
        ? _c(
            "div",
            { staticClass: "row mb-3" },
            _vm._l(_vm.step.steps, function(step, index) {
              return _c("div", { key: "step-" + index, staticClass: "col-3" }, [
                _c("div", { staticClass: "step-wrapper" }, [
                  _c("span", { staticClass: "step-number" }, [
                    _vm._v(_vm._s(step.stepNumber))
                  ]),
                  _c(
                    "span",
                    { staticClass: "step-delete" },
                    [
                      _c("vs-icon", {
                        attrs: {
                          icon: "highlight_off",
                          size: "small",
                          bg: "white",
                          round: ""
                        },
                        on: {
                          click: function($event) {
                            return _vm.removeStep(step)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c("div", { staticClass: "text-center step-name" }, [
                    _vm._v(" " + _vm._s(step.responsibleName) + " ")
                  ]),
                  _c("div", { staticClass: "step-type" }, [
                    step.stepType === _vm.stepTypes.USER
                      ? _c("span", [_vm._v(" usuario ")])
                      : _vm._e(),
                    step.stepType === _vm.stepTypes.OFFICE
                      ? _c("span", [_vm._v(" oficina ")])
                      : _vm._e()
                  ]),
                  _c("div", { staticClass: "step-rol" }, [
                    step.rolType === _vm.rolTypes.APPROVER
                      ? _c("span", [_vm._v(" aprobador ")])
                      : _vm._e(),
                    step.stepType !== _vm.stepTypes.OFFICE &&
                    step.rolType === _vm.rolTypes.SIGNER
                      ? _c("span", [_vm._v(" firmante ")])
                      : _vm._e(),
                    step.rolType === _vm.rolTypes.REVIEWER
                      ? _c("span", [_vm._v(" revisor ")])
                      : _vm._e(),
                    step.stepType === _vm.stepTypes.OFFICE &&
                    step.rolType === _vm.rolTypes.SIGNER
                      ? _c("span", [_vm._v(" num/tramitar ")])
                      : _vm._e()
                  ])
                ])
              ])
            }),
            0
          )
        : _vm._e(),
      _vm.error.message !== ""
        ? _c(
            "div",
            {
              staticClass:
                "con-text-validation span-text-validation-danger\n         vs-input--text-validation-span v-enter-to text-right",
              staticStyle: { height: "32px" }
            },
            [
              _c("span", { staticClass: "span-text-validation" }, [
                _vm._v(" " + _vm._s(_vm.error.message) + " ")
              ])
            ]
          )
        : _vm._e(),
      _vm.showDistribution
        ? _c(
            "div",
            [
              _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "b-modal",
                      rawName: "v-b-modal",
                      value: "modal-subjects",
                      expression: "'modal-subjects'"
                    },
                    {
                      name: "ripple",
                      rawName: "v-ripple.400",
                      value: "rgba(113, 102, 240, 0.15)",
                      expression: "'rgba(113, 102, 240, 0.15)'",
                      modifiers: { "400": true }
                    }
                  ],
                  staticClass: "btn-icon shadow-lg mt-4",
                  attrs: {
                    variant: _vm.wizardData.haveSubjects
                      ? "outline-success"
                      : _vm.isDistributionRequired
                      ? "outline-warning"
                      : "outline-info",
                    "data-cy": "btn-destinations"
                  }
                },
                [
                  _vm._v(" Distribución "),
                  _c("feather-icon", { attrs: { icon: "UsersIcon" } })
                ],
                1
              ),
              _c("UpdateSubjectsFile", {
                attrs: {
                  wizard: _vm.wizard,
                  "document-id": _vm.wizardData.documentId,
                  participants: _vm.wizardData.subjects
                },
                on: { "file-updated": _vm.markFileUpdated }
              })
            ],
            1
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }